import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnDestroy,
    Output,
    SimpleChanges,
    TemplateRef,
    ViewChild,
} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {DialogService} from '../../service/dialog.service';
import {SidebarDialogContentHostComponent, SidebarDialogData} from './host/sidebar-dialog-content-host.component';

@Component({
    selector: 'ui-kit-sidebar-dialog',
    template: '<ng-template #content><ng-content/></ng-template>',
    styleUrl: './sidebar-dialog.component.scss',
    standalone: false
})
export class SidebarDialogComponent implements AfterViewInit, OnChanges, OnDestroy {
    @Input() display = false;
    @Output() displayChange = new EventEmitter<boolean>();

    @Input() direction: 'left' | 'right' = 'left';
    @Input() width: number;

    @ViewChild('content', {static: true}) content: TemplateRef<any>;

    private ref: MatDialogRef<any>;

    constructor(
        private dialogService: DialogService,
    ) {
    }

    ngAfterViewInit(): void {
        if (this.display) {
            this.open();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if ('display' in changes && !changes.display.firstChange) {
            this.display ? this.open() : this.close();
        }
    }

    ngOnDestroy(): void {
        this.close();
    }

    private open(): void {
        if (this.ref) {
            return;
        }

        const data: SidebarDialogData = {template: this.content};
        this.ref = this.dialogService.showCustomDialog(
            SidebarDialogContentHostComponent,
            data,
            {
                panelClass: ['ui-kit-dialog', 'ui-kit-sidebar-dialog', this.direction],
                width: `${this.width}px`,
                height: '100vh',
                position: this.direction === 'left' ? {top: '0', right: '0'} : {top: '0', left: '0'},
                enterAnimationDuration: '0ms',
                exitAnimationDuration: '0ms',
            },
        );

        this.ref.afterClosed().subscribe(() => {
            this.display = false;
            this.displayChange.emit(false);
        });
    }

    private close(): void {
        if (this.ref) {
            this.ref.close();
            this.ref = undefined;
        }
    }
}
